import React, { useState, useEffect } from "react";
import NavbarManager, { infoUtente, loadNav } from "./Navbar";
import Table from "../../components/Table";
import Loader from "../../components/Loader";
import Alert from "../../components/Alert";
import { useNavigate } from "react-router-dom";

const RowPC = ({ data }) => {

    return (
        <div className="grid grid-cols-8 py-4 border-b-2 border-gray-300 dark:border-neutral-700 w-full">
            <div className="flex items-center pl-2 ">
                {data.value.Data}
            </div>
            <div className="flex items-center pl-2 ">
                {data.value.Descrizione}
            </div>
            <div className="flex items-center pl-2 ">
                {data.value.Utente}
            </div>
            <div className="flex items-center pl-2 ">
                {data.value.Azienda}
            </div>
            <div className="flex items-center pl-2 ">
                {data.value.CodiceComponente}
            </div>
            <div className="flex items-center pl-2 ">
                {data.value.DescrizioneComponente}
            </div>
            <div className="flex items-center pl-2 ">
                {data.value.Impianto}
            </div>
            <div className="flex items-center pl-2" style={{ color: data.value.ColoreStato || 'inherit' }}>
                {data.value.StatoAssunto}
            </div>
        </div>
    );
};

const RowMobile = ({ data, headers, keyForPreview }) => {
    return (
        <>
            {
                headers.map(header => (
                    !keyForPreview.includes(header.key) && (
                        <div key={`mobile-detail-${header.key}`} className="mb-2">
                            <span className="font-medium text-sm text-gray-500 dark:text-gray-400">
                                {header.label}:
                            </span>
                            <span className="ml-1 text-sm" style={header.key === 'StatoAssunto' ? { color: data.value.ColoreStato || 'inherit' } : {}}>
                                {data.value[header.key]}
                            </span>
                        </div>
                    )
                ))
            }
        </>
    );
};

const Log = () => {
    const headers = [
        { label: 'Data', key: 'Data' },
        { label: 'Descrizione Manutenzione', key: 'Descrizione' },
        { label: 'Utente', key: 'Utente' },
        { label: 'Cliente', key: 'Azienda' },
        { label: 'Nome Componente', key: 'CodiceComponente' },
        { label: 'Descrizione Componente', key: 'DescrizioneComponente' },
        { label: 'Sito', key: 'Impianto' },
        { label: 'Stato', key: 'StatoAssunto' }
    ];
    const [dataTable, setDataTable] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ type: "info", text: "", onClose: () => setShowAlert(false), needConfirm: false, onConfirm: () => { } });

    useEffect(() => {
        onload();
    }, []);

    const onload = async () => {
        setIsLoading(true);
        //getInfoUtente
        try {

            await loadNav();

            //loadDati
            const r2 = await fetch('/getLog', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente.CodiceDominio
                })
            });
            const rd2 = await r2.json();
            if (r2.status === 500) {
                console.log(rd2.error);
                setAlertInfo({ type: "error", text: rd2.error, onClose: () => { setShowAlert(false); navigate('/manager/dash'); }, needConfirm: false });
                setShowAlert(true);
            } else {
                setDataTable(rd2.map(item => ({ value: item })));
            }

        } catch (error) {
            console.log(error);
            setAlertInfo({ type: "error", text: "Errore nel caricamento della pagina, riprovare più tardi", onClose: () => { setShowAlert(false); navigate('/manager/dash'); }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    return (
        <div className="h-[100svh]">
            <NavbarManager page={"LOG"} />
            {isLoading && <Loader />}
            {showAlert && <Alert type={alertInfo.type} text={alertInfo.text} onClose={alertInfo.onClose} needConfirm={alertInfo.needConfirm} onConfirm={alertInfo.onConfirm} />}
            <div className="h-[93%] overflow-y-auto px-4">
                <Table
                    headers={headers}
                    keyForPreview={['Data', 'Utente', 'Descrizione']}
                    data={dataTable}
                    setData={setDataTable}
                    renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPC data={rowData} />}
                    renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} />}
                    itemsPC={9}
                    itemsMobile={7}
                    needResearch={true}
                    classes="mt-2"
                />
            </div >
        </div >
    )
};

export default Log;